import axios from 'axios';
import { API_URL, axiosConfig } from '../../app/api.js';

const withCredentials = { ...axiosConfig, withCredentials: true };

export const getNetworkDashboard = (params) =>
    axios.get(`${API_URL}/partner/network/dashboard`, { ...withCredentials, params }).then((r) => r.data);

export const getNetworkLevels = (params) =>
    axios.get(`${API_URL}/partner/network/levels`, { ...withCredentials, params }).then((r) => r.data);

export const getNetworkTree = (params) =>
    axios.get(`${API_URL}/partner/network/tree`, { ...withCredentials, params }).then((r) => r.data);

export const getNetworkReferrals = (params) =>
    axios.get(`${API_URL}/partner/network/referrals`, { ...withCredentials, params }).then((r) => r.data);

export const getNetworkPartner = (partnerUid, params) =>
    axios.get(`${API_URL}/partner/network/partners/${partnerUid}`, { ...withCredentials, params }).then((r) => r.data);

export const getNetworkInviteLink = () =>
    axios.get(`${API_URL}/partner/network/invite-link`, withCredentials).then((r) => r.data);

export const exportNetworkCsv = (params) =>
    axios.get(`${API_URL}/partner/network/export`, { ...withCredentials, params, responseType: 'blob' }).then((r) => r.data);
